import React from 'react'

function ContactTwo({ className }) {
    return (
        <>
            {/* Contact area Start */}
            <section id="contact" className={`rts-contact-area ${className}`}>
                <div className="container">
                    <div className="section-title-area2">
                        <p
                            className="sub-title wow fadeInUp"
                            data-wow-delay=".2s"
                            data-wow-duration="2s"
                        >
                            Contact us
                        </p>
                        <h2
                            className="section-title wow fadeInUp"
                            data-wow-delay=".5s"
                            data-wow-duration="2s"
                        >
                            Get in Touch with Us!
                        </h2>
                        <p
                            className="desc wow fadeInUp"
                            data-wow-delay=".8s"
                            data-wow-duration="2s"
                        >
                            "Have questions, feedback, or need assistance? We’re here to help!
                            Reach <br /> out to our team, and we’ll get back to you as soon as
                            possible.
                        </p>
                    </div>
                    <div
                        className="form-inner mt--40 wow fadeInUp"
                        data-wow-delay="1.2s"
                        data-wow-duration="2s"
                    >
                        <form action="mailer.php" method="POST" id="contact-form">
                            <div className="form-content-box">
                                <div className="form-group d-flex">
                                    <div className="input-wrapper">
                                        <input
                                            id="name"
                                            name="name"
                                            placeholder="Enter Your Name"
                                            type="text"
                                            required=""
                                        />
                                    </div>
                                    <div className="input-wrapper">
                                        <input
                                            id="email"
                                            name="email"
                                            placeholder="Enter Your Email Address"
                                            type="email"
                                            required=""
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-wrapper">
                                        <input
                                            id="subject"
                                            name="subject"
                                            placeholder="Subject"
                                            type="text"
                                            required=""
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-wrapper">
                                        <textarea
                                            name="message"
                                            id="message"
                                            placeholder="Type Your Message"
                                            required=""
                                            defaultValue={""}
                                        />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="button with-after2">
                                        <button className="rts-btn btn-primary" type="submit">
                                            Send Message
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="form-messages" />
                        </form>
                    </div>
                </div>
            </section>
            {/* Contact area End */}
        </>

    )
}

export default ContactTwo